import React from 'react';
import {SERVER_CDN_PATH} from "../../constants";
const Sidebar = () => {
  return (
      <React.Fragment>
        <div>
          <div className="headline-bar txt-l">
            <p className="headline-bar--txt">No email address?</p>
          </div>

          <div className="email-recommend dib">
            <div className="table">
              <p className="email-recommend__txt table-cell txt-l p15">
                If you don't have an email address, we recommend,{" "}
                <a
                    className="email-recommend__txt--link"
                    target="_blank"
                    href="https://www.google.com/gmail/"
                    title="Google Mail"
                >
                  google mail
                </a>,{" "}
                <a
                    className="email-recommend__txt--link"
                    target="_blank"
                    href="https://mail.yahoo.com/"
                    title="Yahoo! Mail"
                >
                  yahoo mail{" "}
                </a>
                or{" "}
                <a
                    className="email-recommend__txt--link"
                    target="_blank"
                    href="https://outlook.live.com/"
                    title="Microsoft Outlook"
                >
                  microsoft outlook
                </a>.
              </p>

              <div className="email-recommend__box table-cell txt-l">
                <a
                    className="email-recommend__box--link dib gmail"
                    target="_blank"
                    href="https://www.google.com/gmail/"
                    title="Google Mail"
                />
                <a
                    className="email-recommend__box--link dib yahoo"
                    target="_blank"
                    href="https://mail.yahoo.com/"
                    title="Yahoo! Mail"
                />
                <a
                    className="email-recommend__box--link dib outlook"
                    target="_blank"
                    href="https://outlook.live.com/"
                    title="Microsoft Outlook"
                />
              </div>
            </div>
          </div>

        </div>

        <div className="customer" style={{ backgroundImage: `url(/${SERVER_CDN_PATH}/img/banner/biggest-welcome-bonus-l.jpg)` }}/>
        <div className="customer" style={{ backgroundImage: `url(/${SERVER_CDN_PATH}/img/banner/customer-service-02.jpg)` }}/>
        <div className="customer" style={{ backgroundImage: `url(/${SERVER_CDN_PATH}/img/banner/customer-payment-02.jpg)` }}/>
      </React.Fragment>
  );
}

export default Sidebar;
